import { render, staticRenderFns } from "./EditCFCModal.vue?vue&type=template&id=b551d3ce&scoped=true"
import script from "./EditCFCModal.vue?vue&type=script&lang=js"
export * from "./EditCFCModal.vue?vue&type=script&lang=js"
import style0 from "./EditCFCModal.vue?vue&type=style&index=0&id=b551d3ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b551d3ce",
  null
  
)

export default component.exports